import http from '../interceptors/Intercepter';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const retrieveDataCaptureTimelineReport = async (
  studyExternalReference,
  locationExternalReference,
  username
) => {
  try {
    const params = { studyExternalReference, locationExternalReference, username };

    const { data } = await http.get('/api/data-management/view/data-capture-timeline', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadDataCaptureTimelineReport = async (
  studyExternalReference,
  locationExternalReference,
  username
) => {
  try {
    const params = { studyExternalReference, locationExternalReference, username };

    const { data, headers } = await http.get('/api/data-management/view/data-capture-timeline/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveDataCaptureStaffReport = async (dateFrom, dateTo, username) => {
  try {
    const params = { dateFrom, dateTo, username };

    const { data } = await http.get('/api/data-management/view/data-capture-per-staff', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadDataCaptureStaffReport = async (dateFrom, dateTo, username) => {
  try {
    const params = { dateFrom, dateTo, username };

    const { data, headers } = await http.get('/api/data-management/view/data-capture-per-staff/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveSDVCaptureTimelineReport = async (studyExternalReference, locationExternalReference, username) => {
  try {
    const params = { studyExternalReference, locationExternalReference, username };

    const { data } = await http.get('/api/data-management/view/sdv-capture-timeline', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadSDVCaptureTimelineReport = async (studyExternalReference, locationExternalReference, username) => {
  try {
    const params = { studyExternalReference, locationExternalReference, username };

    const { data, headers } = await http.get('/api/data-management/view/sdv-capture-timeline/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveSDVCaptureStaffReport = async (dateFrom, dateTo, username) => {
  try {
    const params = { dateFrom, dateTo, username };

    const { data } = await http.get('/api/data-management/view/sdv-capture-per-staff', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadSDVCaptureStaffReport = async (dateFrom, dateTo, username) => {
  try {
    const params = { dateFrom, dateTo, username };

    const { data, headers } = await http.get('/api/data-management/view/sdv-capture-per-staff/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrievePageTrackerStudyReport = async (username) => {
  try {
    const params = { username };

    const { data } = await http.get('/api/data-management/view/page-tracker-per-study', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadPageTrackerStudyReport = async (username) => {
  try {
    const params = { username };

    const { data, headers } = await http.get('/api/data-management/view/page-tracker-per-study/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveLiveSchedulerStudyReport = async (username) => {
  try {
    const params = { username };

    const { data } = await http.get('/api/data-management/view/live-scheduler-per-study', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadLiveSchedulerStudyReport = async (username) => {
  try {
    const params = { username };

    const { data, headers } = await http.get('/api/data-management/view/live-scheduler-per-study/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveLiveSchedulerParticipantReport = async (
  locationExternalReference,
  studyExternalReference,
  username
) => {
  try {
    const params = { locationExternalReference, studyExternalReference, username };

    const { data } = await http.get('/api/data-management/view/live-scheduler-per-participant', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadLiveSchedulerParticipantReport = async (
  locationExternalReference,
  studyExternalReference,
  username
) => {
  try {
    const params = { locationExternalReference, studyExternalReference, username };

    const { data, headers } = await http.get('/api/data-management/view/live-scheduler-per-participant/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveLiveSchedulerParticipantVisitReport = async (participantExternalReference, username) => {
  try {
    const params = { participantExternalReference, username };

    const { data } = await http.get('/api/data-management/view/live-scheduler-per-participant-visit', {
      ...config,
      params,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadLiveSchedulerParticipantVisitReport = async (participantExternalReference, username) => {
  try {
    const params = { participantExternalReference, username };

    const { data, headers } = await http.get('/api/data-management/view/live-scheduler-per-participant-visit/excel', {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveQualityControlInputs = async (username) => {
  try {
    const params = { username };

    const { data } = await http.get('/api/quality-control/view/input', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveSiteQueryStatusReport = async (username, body) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/quality-control/view/site-query-status', body, { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveParticipantReviewsReport = async (username, body) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/quality-control/view/participant-review', body, { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadParticipantReviewsReport = async (username, body) => {
  try {
    const params = { username };

    const { data, headers } = await http.post('/api/quality-control/view/participant-review/excel', body, {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const downloadSiteQueryStatusReport = async (username, body) => {
  try {
    const params = { username };

    const { data, headers } = await http.post('/api/quality-control/view/site-query-status/excel', body, {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveSiteQueryStatusPerMonthReport = async (username, body) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/quality-control/view/site-query-status-per-month', body, {
      ...config,
      params,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadSiteQueryStatusPerMonthReport = async (username, body) => {
  try {
    const params = { username };

    const { data, headers } = await http.post('/api/quality-control/view/site-query-status-per-month/excel', body, {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveQueryPerStaffReport = async (username, queryStatus, body) => {
  try {
    const params = { username, queryStatus };

    const { data } = await http.post('/api/quality-control/view/query-per-staff', body, { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadQueryPerStaffReport = async (username, queryStatus, body) => {
  try {
    const params = { username, queryStatus };

    const { data, headers } = await http.post('/api/quality-control/view/query-per-staff/excel', body, {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveQueryAgeReport = async (username, queryStatus, body) => {
  try {
    const params = { username, queryStatus };

    const { data } = await http.post('/api/quality-control/view/query-age', body, { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadQueryAgeReport = async (username, queryStatus, body) => {
  try {
    const params = { username, queryStatus };

    const { data, headers } = await http.post('/api/quality-control/view/query-age/excel', body, {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveQueryPerTypeReport = async (username, body) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/quality-control/view/query-per-type', body, { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadQueryPerTypeReport = async (username, body) => {
  try {
    const params = { username };

    const { data, headers } = await http.post('/api/quality-control/view/query-per-type/excel', body, {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};

export const retrieveQueryResolutionTatReport = async (username, body) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/quality-control/view/query-resolution-tat', body, { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const downloadQueryResolutionTatReport = async (username, body) => {
  try {
    const params = { username };

    const { data, headers } = await http.post('/api/quality-control/view/query-resolution-tat/excel', body, {
      ...config,
      params,
      responseType: 'blob',
    });

    return [data, headers, null];
  } catch (error) {
    return [null, null, error];
  }
};
